var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6486 15.8336L9.35219 17.13C7.56229 18.9199 4.66028 18.9199 2.87038 17.13C1.08048 15.3401 1.08048 12.4381 2.87038 10.6482L4.16674 9.35183M15.834 10.6482L17.1304 9.35183C18.9203 7.56192 18.9203 4.65992 17.1304 2.87002C15.3405 1.08011 12.4385 1.08011 10.6486 2.87002L9.35219 4.16638M6.79204 13.2083L13.2087 6.79166",
    stroke: "#70767B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.bfce9489eb24bd72ba840398f18bdf76.svg";
export { ForwardRef as ReactComponent };